export default __webpack_public_path__ + "static/project-slide-1-992-765-7bc339e84239b5ec2525edcef890af0c.webp";